import { render, staticRenderFns } from "./iconKiki.vue?vue&type=template&id=4a9c3f7a&"
import script from "./iconKiki.vue?vue&type=script&lang=js&"
export * from "./iconKiki.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports